import * as React from 'react';

import { cn } from '@/lib/utils';

const Label = React.forwardRef<
  HTMLLabelElement,
  React.LabelHTMLAttributes<HTMLLabelElement>
>(({ className, ...props }, ref) => (
  <label
    ref={ref}
    className={cn(
      'text-muted-foreground inline-flex items-center gap-1.5 text-[11px] font-semibold tracking-[0.12em] uppercase',
      className,
    )}
    {...props}
  />
));
Label.displayName = 'Label';

export { Label };
